export default __webpack_public_path__ + "static/media/logo_slack.b05d6c6c.png";